module.exports = __webpack_public_path__ + "img/05.ad0a8db2.jpg";